import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { compareAlphabetically } from '@shared/utils/helpers/sort-helpers';
import { getCountryLabel } from '../../../../utils/helpers/get-country-label';
import { type MembershipRequirementDimensions } from '../../../../utils/types/membership-requirements';
export const useMembershipRequirementsOptions = dimensions => {
  const $ = _c(10);
  const locale = useLocale();
  let customSortedCountryOptions;
  let t0;
  if ($[0] !== dimensions?.countries || $[1] !== dimensions?.years || $[2] !== locale) {
    const formatter = new Intl.DateTimeFormat(locale, {
      year: "numeric"
    });
    let t1;
    if ($[5] !== dimensions?.countries) {
      const sortedCountries = dimensions?.countries?.sort(_temp).map(_temp2);
      const taiwanCountryOptions = sortedCountries.filter(_temp3);
      const countryOptionsWithoutTaiwanOption = sortedCountries.filter(_temp4);
      const switzerlandOptionIndex = countryOptionsWithoutTaiwanOption.findIndex(_temp5);
      t1 = [...countryOptionsWithoutTaiwanOption.slice(0, switzerlandOptionIndex + 1), ...taiwanCountryOptions, ...countryOptionsWithoutTaiwanOption.slice(switzerlandOptionIndex + 1)];
      $[5] = dimensions?.countries;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    customSortedCountryOptions = t1;
    t0 = dimensions?.years?.sort(_temp6).map(year => ({
      label: formatter.format(new Date(year, 0)),
      value: year
    }));
    $[0] = dimensions?.countries;
    $[1] = dimensions?.years;
    $[2] = locale;
    $[3] = customSortedCountryOptions;
    $[4] = t0;
  } else {
    customSortedCountryOptions = $[3];
    t0 = $[4];
  }
  const yearOptions = t0;
  let t1;
  if ($[7] !== customSortedCountryOptions || $[8] !== yearOptions) {
    t1 = {
      countryOptions: customSortedCountryOptions,
      yearOptions
    };
    $[7] = customSortedCountryOptions;
    $[8] = yearOptions;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
function _temp(countryA, countryB) {
  return compareAlphabetically(countryA.name, countryB.name);
}
function _temp2(t0) {
  const {
    code,
    name
  } = t0;
  return {
    countryName: name,
    label: getCountryLabel(code, name),
    value: code
  };
}
function _temp3(country) {
  return country.value === "TW";
}
function _temp4(country_0) {
  return country_0.value !== "TW";
}
function _temp5(country_1) {
  return country_1.value === "CH";
}
function _temp6(yearA, yearB) {
  return yearA - yearB;
}